import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { EmployeeValidationModel } from './employee-validation.model';
import { EfaactDataService } from '../efaact.data-service';

export const entityName = 'EmployeeValidation';
@Injectable({ providedIn: 'root' })
export class EmployeeValidationDataService extends EfaactDataService<EmployeeValidationModel> {
    mapItems(item: EmployeeValidationModel): EmployeeValidationModel {
        return item;
        // return {
        //     ...item,
        //     id: item.RowNumber
        // };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
